/* eslint-disable @typescript-eslint/naming-convention */

export const VALUE = {
  DEFAULT_MIN_DATE: "2000-01-01",
  DEFAULT_MAX_DATE: "3000-01-01",
};
